export const SECTION_LABELS = {
  workExperience: { en: 'Work Experience', da: 'Erhvervserfaring' },
  education: { en: 'Education', da: 'Uddannelse' },
  softSkills: { en: 'Soft Skills', da: 'Personlige kompetencer' },
  languages: { en: 'Languages', da: 'Sprog' },
  spareTime: { en: 'Spare Time', da: 'Fritid' },
  otherExperience: { en: 'Other Experience', da: 'Øvrig erfaring' },
};

export const SUPPORTED_LANGUAGES = ['en', 'da'];
export const DEFAULT_LANGUAGE = 'en';
